import React from "react";
import {TextInputField, Dialog, Pane, Button, toaster, EyeOpenIcon, EyeOffIcon} from "evergreen-ui";
import {getCountryCodes, createUser} from "../external/actions"
import {connect} from "react-redux";
import CountryCodeSelector from "../components/countryCodeSelector"
import validator from "validator";

class AddDeskPersonDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedCountryCode: "+91",
            firstName: "",
            isFirstNameInvalid: false,
            lastName: "",
            email: "",
            isEmailInvalid: false,
            contactNumber: "",
            isContactNumberInvalid: false,
            userName: "",
            isUsernameInvalid: false,
            password: "",
            isPasswordInvalid: false,
            passwordInvalidMsg: "",
            showPasswordInvalidMsg: false,
            confirmPassword: "",
            isConfirmPasswordInvalid: false,
            showConfirmPasswordInvalidMsg: false,
            confirmPasswordInvalidMsg: "",
            showPasswordsMatchAlert: false,
            passwordEye: false
        };
        this.baseState = this.state
    }

    async componentDidMount() {
        await this.props.dispatch(getCountryCodes())
    }

    changeCountryCode = async (countryCode) => {
        this.setState({
            selectedCountryCode: countryCode
        })
    };

    onCloseDialog = () => {
        const {
            showDialog
        } = this.props;

        this.setState({
            ...this.baseState
        });
        showDialog(false)
    };

    // -----------------------------------------------------------------------
    // inputChange()
    // -----------------------------------------------------------------------
    inputChange = async (e, type) => {
        e.persist();
        if (type === "first-name") {
            if (e.target.value.length > 0) {
                this.setState({
                    firstName: e.target.value.toString()
                });
                await this.setState({isFirstNameInvalid: false});
            } else {
                this.setState({
                    firstName: e.target.value.toString()
                });
                await this.setState({isFirstNameInvalid: true});
            }
        } else if (type === "last-name") {
            await this.setState({lastName: e.target.value.toString()});
        } else if (type === "email") {
            if (e.target.value.length > 0) {
                await this.setState({email: e.target.value.toString()});
            } else {
                await this.setState({
                    email: e.target.value.toString(),
                    isEmailInvalid: false
                });
            }
        } else if (type === "contact-number") {
            if (e.target.value.length > 0) {
                await this.setState({contactNumber: e.target.value.toString()});
            } else {
                await this.setState({
                    contactNumber: e.target.value.toString(),
                    isContactNumberInvalid: false
                });
            }
        } else if (type === "username") {
            if (e.target.value.length > 0) {
                await this.setState({
                    userName: e.target.value.toString(),
                    isUsernameInvalid: false
                });
            } else {
                await this.setState({
                    userName: e.target.value.toString(),
                    isUsernameInvalid: true
                });
            }
        } else if (type === "password") {
            if (e.target.value.length > 0) {
                await this.setState({
                    password: e.target.value.toString(),
                    isPasswordInvalid: false,
                    showPasswordInvalidMsg: false,
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            } else {
                await this.setState({
                    password: e.target.value.toString(),
                    isPasswordInvalid: true,
                    passwordInvalidMsg: "Password is required",
                    showPasswordInvalidMsg: true,
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            }
        } else if (type === "confirm-password") {
            if (e.target.value.length > 0) {
                await this.setState({
                    confirmPassword: e.target.value.toString(),
                    isConfirmPasswordInvalid: false,
                    showConfirmPasswordInvalidMsg: false
                });
            } else {
                await this.setState({
                    confirmPassword: e.target.value.toString()
                });
            }
        }
    };

    validateEmail = e => {
        const {
            email,
        } = this.state;

        e.persist();
        if (email.length > 0) {
            if (validator.isEmail(email)) {
                this.setState({isEmailInvalid: false});
            } else {
                this.setState({isEmailInvalid: true});
            }
        }
    };

    validateMobile = e => {
        const {
            contactNumber,
        } = this.state;

        e.persist();
        if (contactNumber.length > 0) {
            if (validator.isMobilePhone(contactNumber)) {
                this.setState({isContactNumberInvalid: false});
            } else {
                this.setState({isContactNumberInvalid: true});
            }
        }
    };

    confirmAddDeskPerson = async () => {

        const {
            firstName,
            userName,
            isContactNumberInvalid,
            isEmailInvalid,
            password,
            confirmPassword,
            selectedCountryCode,
            lastName,
            email,
        } = this.state;

        const {
            showDialog,
        } = this.props;

        if (
            firstName !== "" &&
            userName !== "" &&
            !isContactNumberInvalid &&
            !isEmailInvalid &&
            password !== "" &&
            confirmPassword !== "" &&
            password === confirmPassword
        ) {
            let contactNumber;
            contactNumber = contactNumber ? selectedCountryCode + contactNumber : "";
            let reqBody = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: contactNumber,
                username: userName,
                password: password,
                features: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
            };
            await this.props.dispatch(createUser(reqBody));
            if (this.props.deskUserData["requestStatus"] === 1) {
                toaster.success(this.props.deskUserData.message);
                this.setState({
                    ...this.baseState
                });
                showDialog(false)
            } else {
                toaster.danger(this.props.deskUserData.message)
            }
        } else {
            if (firstName === "") {
                await this.setState({isFirstNameInvalid: true});
            }
            if (userName === "") {
                await this.setState({isUsernameInvalid: true});
            }
            if (password === "") {
                await this.setState({
                    isPasswordInvalid: true,
                    passwordInvalidMsg: "Password is required",
                    showPasswordInvalidMsg: true
                });
            }
            if (password !== "" && confirmPassword === "") {
                await this.setState({
                    isConfirmPasswordInvalid: true,
                    confirmPasswordInvalidMsg: "Please enter password again",
                    showConfirmPasswordInvalidMsg: true
                });
            }
            if (
                password.length > 0 &&
                confirmPassword.length > 0 &&
                password !== confirmPassword
            ) {
                await this.setState({
                    isConfirmPasswordInvalid: true,
                    confirmPasswordInvalidMsg: "Passwords do not match",
                    showConfirmPasswordInvalidMsg: true
                });
            }
        }
    };

    changePasswordEye = async () => {
        const {
            passwordEye
        } = this.state;
        await this.setState({passwordEye: !passwordEye});
    };

    render() {
        const {
            selectedCountryCode,
            firstName,
            isFirstNameInvalid,
            lastName,
            email,
            isEmailInvalid,
            contactNumber,
            isContactNumberInvalid,
            userName,
            isUsernameInvalid,
            password,
            isPasswordInvalid,
            passwordInvalidMsg,
            showPasswordInvalidMsg,
            confirmPassword,
            isConfirmPasswordInvalid,
            confirmPasswordInvalidMsg,
            showConfirmPasswordInvalidMsg,
            passwordEye
        } = this.state;

        const {
            isShown
        } = this.props;

        return (

            <Dialog
                isShown={isShown}
                title="Add Desk Person"
                onCloseComplete={() => this.onCloseDialog()}
                hasFooter={false}
            >
                <Pane
                    marginBottom={20}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                >
                    <TextInputField
                        width={"90%"}
                        label="First Name"
                        placeholder="First Name"
                        value={firstName}
                        required
                        isInvalid={isFirstNameInvalid}
                        validationMessage={isFirstNameInvalid && "First name is required"}
                        onChange={e => this.inputChange(e, "first-name")}
                    />
                    <TextInputField
                        width={"90%"}
                        label="Last Name"
                        placeholder="Last Name (Optional)"
                        value={lastName}
                        onChange={e => this.inputChange(e, "last-name")}
                    />
                    <TextInputField
                        width={"90%"}
                        label="Email"
                        placeholder="Email Address (Optional)"
                        value={email}
                        isInvalid={isEmailInvalid}
                        onChange={e => this.inputChange(e, "email")}
                        onBlur={e => this.validateEmail(e)}
                        validationMessage={isEmailInvalid && "Invalid email"}
                    />
                    {/*<Pane*/}
                        {/*marginBottom={isContactNumberInvalid ? 10 : 20}*/}
                        {/*width={"90%"}*/}
                    {/*>*/}
                        {/*<Strong*/}
                            {/*fontWeight={500}*/}
                            {/*height={20}*/}
                        {/*>*/}
                            {/*Mobile*/}
                        {/*</Strong>*/}
                        {/*<Pane*/}
                            {/*display={"flex"}*/}
                            {/*flexDirection={"row"}*/}
                            {/*justifyContent={"flex-start"}*/}
                        {/*>*/}
                            {/*<CountryCodeSelector*/}
                                {/*height={32}*/}
                                {/*selectedCountryCode={selectedCountryCode}*/}
                                {/*changeCountryCode={this.changeCountryCode}*/}
                            {/*/>*/}
                            {/*<TextInput*/}
                                {/*isInvalid={isContactNumberInvalid}*/}
                                {/*width={"75%"}*/}
                                {/*placeholder="Contact Number (Optional)"*/}
                                {/*value={contactNumber}*/}
                                {/*onChange={(e) => this.inputChange(e, "contact-number")}*/}
                                {/*type={"tel"}*/}
                                {/*onBlur={e => this.validateMobile(e)}*/}
                            {/*/>*/}
                        {/*</Pane>*/}
                        {/*{isContactNumberInvalid && <InlineAlert*/}
                            {/*marginTop={5}*/}
                            {/*intent="danger"*/}
                        {/*>*/}
                            {/*<Small color={"#bf0e08"} fontWeight={400}>Enter a valid mobile number</Small>*/}
                        {/*</InlineAlert>}*/}
                    {/*</Pane>*/}
                    <TextInputField
                        width={"90%"}
                        required
                        label="Username"
                        placeholder="Login Username"
                        value={userName}
                        isInvalid={isUsernameInvalid}
                        validationMessage={
                            isUsernameInvalid && "Username is required"
                        }
                        onChange={e => this.inputChange(e, "username")}
                    />
                    <TextInputField
                        width={"90%"}
                        label="Password"
                        required
                        placeholder="Account Password"
                        type={passwordEye ? "text" : "password"}
                        autoComplete="new-password"
                        value={password}
                        isInvalid={isPasswordInvalid}
                        validationMessage={
                            showPasswordInvalidMsg && passwordInvalidMsg
                        }
                        onChange={e => this.inputChange(e, "password")}
                    />
                    <Pane
                        width={"90%"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <TextInputField
                            width={"90%"}
                            label="Confirm Password *"
                            placeholder="Re-enter Password"
                            type={passwordEye ? "text" : "password"}
                            autoComplete="new-password"
                            value={confirmPassword}
                            isInvalid={isConfirmPasswordInvalid}
                            validationMessage={
                                showConfirmPasswordInvalidMsg && confirmPasswordInvalidMsg
                            }
                            onChange={e =>
                                this.inputChange(e, "confirm-password")
                            }
                        /> 
                        {
                            passwordEye ?
                                <EyeOpenIcon 
                                    color="muted"
                                    onClick={() => this.changePasswordEye()}
                                />
                                :
                                <EyeOffIcon 
                                    color="muted" 
                                    onClick={() => this.changePasswordEye()}
                                />
                        }
                    </Pane>
                    <Pane
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                    >
                        <Button
                            appearance="primary"
                            margin={"auto"}
                            onClick={e => this.confirmAddDeskPerson(e)}
                        >
                            Add Desk Person
                        </Button>
                    </Pane>
                </Pane>
            </Dialog>
        )
    }
}

const mapStateToProps = (
    {
        deskUserData
    }) => ({
        deskUserData
    }
);

export default connect(mapStateToProps)(AddDeskPersonDialog);
